// tslint:disable:no-any

import * as React from 'react';
import ReactPaginate from 'react-paginate';
import DisplayTimeByTimeStamp from '../components/Display';

export interface IEventsProps {
    data: any;
}

interface IEventState {
    data: any;
    pageCount: number;
    recordsOnPage: number;
    offset: number;
}

export default class Events extends React.Component<IEventsProps, IEventState> {
    constructor(props: IEventsProps) {
        super(props);

        this.state = {
            data: props.data,
            pageCount: 0,
            recordsOnPage: 15,
            offset: 0
        };
    }

    componentDidMount() {
        this.refreshPageCount();
    }

    componentWillReceiveProps(nextProps: IEventsProps) {
        this.setState(
            {
                data: nextProps.data
            },
            () => {
                this.refreshPageCount();
            }
        );
    }

    refreshPageCount() {
        var newPageCount = Math.ceil(
            this.state.data.length / this.state.recordsOnPage
        );
        if (newPageCount !== this.state.pageCount) {
            this.setState({
                pageCount: newPageCount
            });
        }
    }

    handlePageClick(e: any) {
        this.setState({
            offset: e.selected
        });
    }

    render() {
        var recordsFrom = this.state.offset * this.state.recordsOnPage;
        var recordsTo = recordsFrom + this.state.recordsOnPage - 1;

        return (
            <table className="standardTable">
                <thead>
                    <tr>
                        <th style={{ width: 100 }}>Time</th>
                        <th style={{ width: 150 }}>Type</th>
                        <th style={{ width: 180 }}>Event</th>
                        <th className="text-left">Description</th>
                    </tr>
                </thead>

                <tbody>
                    {this.state.data !== undefined &&
                        this.state.data.map((event: any, index: number) => {
                            if (index >= recordsFrom && index <= recordsTo) {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <DisplayTimeByTimeStamp
                                                data={event.timestamp}
                                            />
                                        </td>
                                        <td>{event.type}</td>
                                        <td>{event.subType}</td>
                                        <td className="text-left">
                                            {event.description}
                                        </td>
                                    </tr>
                                );
                            } else {
                                return null;
                            }
                        })}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={6} className="standardTable__pagination">
                            {this.state.pageCount > 0 && (
                                <ReactPaginate
                                    previousLabel={
                                        <span className="noSelect">
                                            Previous
                                        </span>
                                    }
                                    nextLabel={
                                        <span className="noSelect">Next</span>
                                    }
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={(e: any) =>
                                        this.handlePageClick(e as any)
                                    }
                                    containerClassName={'pagination noSelect'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                />
                            )}
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveEvents.tsx